import { semverToVersionNumber } from '@connect-x-app/shared-utils';
import { version } from '@connect-x-app/version';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { addStore } from './storeRegistry';

const CURRENT_APP_VERSION = semverToVersionNumber(version);

export const createPersistedStore = <T>(
  initializer: Parameters<typeof persist<T>>[0],
  baseOptions: Parameters<typeof persist<T>>[1],
) => {
  const options: Parameters<typeof persist<T>>[1] = {
    ...baseOptions,
    migrate: (persistedState: unknown, version: number) => {
      if (version !== CURRENT_APP_VERSION) {
        return {} as T;
      }
      return persistedState as T;
    },
    version: CURRENT_APP_VERSION,
  };
  const store = create(persist<T>(initializer, options));

  addStore({
    name: options.name,
    reset: () => {
      store.setState(store.getInitialState());
    },
  });

  return store;
};
